import { render, staticRenderFns } from "./AudioThumb.vue?vue&type=template&id=0fdaf6e0&scoped=true&"
import script from "./AudioThumb.vue?vue&type=script&lang=js&"
export * from "./AudioThumb.vue?vue&type=script&lang=js&"
import style0 from "./AudioThumb.vue?vue&type=style&index=0&id=0fdaf6e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdaf6e0",
  null
  
)

export default component.exports